import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSelect',
  props: {
    value: null,
    items: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (e: 'input', value: T): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
	value: T;
	items: { name: string; value: T }[];
};





function handleInput(e: Event) {
	const target = e.target as HTMLSelectElement;
	const selectedItem = props.items[target.selectedIndex];

	if (selectedItem) {
		emit('input', selectedItem.value);
	}
}

return { __sfc: true,props, emit, handleInput }
}

})